export const EVENT_RESPONSE_ENUM = {
  YES: 'yes',
  NO: 'no',
  MAYBE: 'maybe'
};
